/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import * as actions from 'state/action-types';
import receiveConnectionLocations from './receive-connection-locations';

export default (connectionId) => (dispatch) => {
    dispatch({
        type: actions.CONNECTION_LOCATIONS_REQUEST,
    });

    return cecSdk
        .connectionLocation(connectionId)
        .getConnectionLocations()
        .then((locations) => {
            dispatch({
                type: actions.CONNECTION_LOCATIONS_REQUEST_SUCCESS,
            });
            
            dispatch(receiveConnectionLocations(locations));
            return locations;
        })
        .catch((e) => {
            dispatch({ type: actions.CONNECTION_LOCATIONS_REQUEST_FAILURE, error: e.message });
            throw e;
        });
};
